import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';

interface GoogleLoginProps {
  onSuccess?: () => void;
}

export function GoogleLogin({ onSuccess }: GoogleLoginProps = {}) {
  const { signInWithGoogle } = useAuth();
  const [searchParams] = useSearchParams();

  const handleGoogleLogin = async () => {
    try {
      // Prefer explicit redirect query param; otherwise use current location so users return to the same page
      const redirectTo = searchParams.get('redirect') || `${window.location.pathname}${window.location.search}`;
      await signInWithGoogle(redirectTo);
      // Call onSuccess if provided (for modal closing, etc.)
      onSuccess?.();
    } catch (error) {
      console.error('Google sign-in error:', error);
      toast.error('Failed to sign in with Google. Please try again.');
    }
  };

  return (
    <div className="flex justify-center">
      <Button
        variant="outline"
        type="button"
        onClick={handleGoogleLogin}
        className="w-full h-12 text-base font-semibold"
        size="lg"
      >
        <svg className="mr-3 h-5 w-5" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512">
          <path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path>
        </svg>
        Google
      </Button>
    </div>
  );
} 